import React from 'react';
import vcf from 'vcf';
import './V.css';



const Vcard: React.FC = () => {
    const handleDownload = () => {
        // Manually construct the vCard content
        const vCardContent = `
BEGIN:VCARD
VERSION:3.0
FN:تعافي
ORG:غادة بولس عيادة تعافي الناصرة
TEL:054-571-7774
BDAY:1985-01-01
TITLE:غادة بولس عيادة تعافي الناصرة
URL:
NOTE:Taafii
END:VCARD
        `.trim();

        // Encode as UTF-8
        const utf8Encoder = new TextEncoder();
        const vCardBlob = new Blob([utf8Encoder.encode(vCardContent)], { type: 'text/vcard;charset=utf-8' });

        // Create a link and trigger the download
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(vCardBlob);
        link.download = 'غادة بولس عيادة تعافي الناصرة.vcf';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="vcard-container">
            <button className="download-button" onClick={handleDownload}>
                اضغط لإضافة رقمنا            </button>
        </div>
    );
};

export default Vcard;

